import DropdownAction from 'components/DropdownAction';
import {FC} from 'react';
import {useTranslation} from 'react-i18next';

interface PayDropdownOptionProps {
    moneyRequest: {
        cancelled: boolean;
        paid: boolean;
    } | null;
    onClick: () => void;
}

const PayDropdownOption: FC<PayDropdownOptionProps> = ({
    moneyRequest,
    onClick,
}) => {
    const {t} = useTranslation('Portal');

    if (!moneyRequest || moneyRequest.cancelled) return null;

    return (
        <DropdownAction.Button disabled={moneyRequest.paid} onClick={onClick}>
            {moneyRequest.paid ? t('inbox.paid') : t('inbox.pay')}
        </DropdownAction.Button>
    );
};

export default PayDropdownOption;
